import { createStore } from 'vuex'
import UserModule from './user'
import GoGameModule from './game'
import PuzzleModule from './puzzle'

export default createStore({
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
    },
    modules: {
        user: UserModule,
        gogame: GoGameModule,
        puzzle: PuzzleModule,
    }
})
